<template>
  <div class="import-users-view-container">
    <b-form
      @submit="handleSubmit"
      v-if="Object.keys(responseData).length === 0"
    >
      <h1>Import Users</h1>
      <b-form-group
        label="User Type"
        :state="userTypeValidation"
        :disabled="submitting"
      >
        <b-form-radio v-model="userType" :value="userTypeValues.student"
          >Students</b-form-radio
        >
        <b-form-radio v-model="userType" :value="userTypeValues.mentor"
          >Mentors</b-form-radio
        >
        <b-form-invalid-feedback :state="userTypeValidation"
          >You must select a user type</b-form-invalid-feedback
        >
      </b-form-group>
      <template v-if="Object.values(userTypeValues).includes(userType)">
        <b-form-group :disabled="submitting">
          <b-form-file
            class=""
            v-model="formData.file"
            :state="formFileValidation"
            placeholder="Choose a file (or drag and drop)"
            drop-placeholder="Drop file here"
          ></b-form-file>
          <b-form-invalid-feedback :state="formFileValidation"
            >You must select a file to upload</b-form-invalid-feedback
          >
          <div class="mt-3">
            Selected file: {{ formData.file ? formData.file.name : "" }}
          </div>
        </b-form-group>
      </template>
      <b-button
        variant="primary"
        type="submit"
        class="red"
        :disabled="submitting"
        ><b-spinner
          class="submit-spinner"
          label="loading"
          variant="secondary"
          v-if="submitting"
        ></b-spinner>
        {{ submitting ? "Submitting" : "Submit" }}</b-button
      >
    </b-form>
    <template v-if="Object.keys(responseData).length > 0">
      <h1 class="mt-2">Import results</h1>
      <h4>Successfully added</h4>
      <ul class="scrollable-list" v-if="responseData.added.length > 0">
        <li v-for="email in responseData.added" :key="email">
          {{ email }}
        </li>
      </ul>
      <p v-else>No users were added.</p>
      <h4>Already existing</h4>
      <ul class="scrollable-list" v-if="responseData.alreadyPresent.length > 0">
        <li v-for="email in responseData.alreadyPresent" :key="email">
          {{ email }}
        </li>
      </ul>
      <p v-else>n/a</p>
      <h4>Failed to add</h4>
      <ul class="scrollable-list" v-if="responseData.failedToAdd.length > 0">
        <li v-for="email in responseData.failedToAdd" :key="email">
          {{ email }}
        </li>
      </ul>
      <p v-else>n/a</p>
      <h4>Imported, but failed to add roles</h4>
      <ul
        class="scrollable-list"
        v-if="responseData.failedToAddRoles.length > 0"
      >
        <li v-for="email in responseData.failedToAddRoles" :key="email">
          {{ email }}
        </li>
      </ul>
      <p v-else>n/a</p>
      <h4>Malformed Lines</h4>
      <ul
        class="scrollable-list"
        v-if="Object.keys(responseData.badLines).length > 0"
      >
        <li v-for="(rowText, line) in responseData.badLines" :key="line">
          Line {{ line }}: {{ rowText }}
        </li>
      </ul>
      <p v-else>n/a</p>
      <p>
        <b-button variant="primary" class="red" @click="handleImportAgainClick"
          >import another batch</b-button
        >
      </p>
    </template>
  </div>
</template>

<script>
import {
  BForm,
  BFormGroup,
  BFormRadio,
  BFormFile,
  BButton,
  BSpinner,
  BFormInvalidFeedback
} from "bootstrap-vue";
import MentorApplicationApi from "@/components/lib/MentorApplicationApi";
export default {
  name: "ImportUsersView",
  components: {
    BForm,
    BFormFile,
    BFormGroup,
    BFormRadio,
    BButton,
    BSpinner,
    BFormInvalidFeedback
  },
  computed: {
    formFileValidation() {
      return this.validate ? Boolean(this.formData.file) : null;
    },
    userTypeValidation() {
      return this.validate
        ? Object.values(this.userTypeValues).includes(this.userType)
        : null;
    },
    hasValidationErrors() {
      let valuesToCheck = [this.formFileValidation, this.userTypeValidation];
      return valuesToCheck.some(x => x !== true);
    }
  },
  methods: {
    handleImportAgainClick(e) {
      e.preventDefault();
      location.reload();
    },
    handleSubmit(e) {
      e.preventDefault();
      this.validate = true;
      if (this.hasValidationErrors) {
        return;
      }
      this.submitting = true;
      let that = this;
      this.mentorApplicationApi
        .importUsers(this.userType, this.formData)
        .then(
          success => {
            that.responseData = success.data;
            that.submitting = false;
          },
          error => {
            alert(
              `Error importing users: ${
                error.response.data.error
                  ? error.response.data.error
                  : "unknown error"
              }`
            );
            that.submitting = false;
          }
        )
        .catch(() => {
          alert("Unknown error encountered while importing users.");
          that.submitting = false;
        });
    }
  },
  data() {
    return {
      submitting: false,
      validate: false,
      userTypeValues: {
        student: "Students",
        mentor: "Mentors"
      },
      responseData: {},
      userType: null,
      // as userType is not submitted as a form field via the API, it's not included in the formData collection
      // -- however, userType has the normal validation approach
      formData: {
        file: null
      },
      mentorApplicationApi: new MentorApplicationApi(this.apiRootUrl)
    };
  },
  props: {
    apiRootUrl: { type: String, required: true }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.scrollable-list {
  max-height: 200px;
  overflow-y: auto;
}
</style>
